import { Icon, IconProps } from "@chakra-ui/react";

export default function Sort(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 20" fill="none" {...props}>
      <path
        d="M5.27208 1.15967C5.29631 1.16063 5.32033 1.16284 5.34435 1.1665C5.36186 1.16918 5.37907
        1.17223 5.3961 1.17627C5.42035 1.182 5.44381 1.19018 5.46739 1.19873C5.48041 1.20348
        5.49384 1.20686 5.50645 1.2124C5.53038 1.22286 5.55301 1.23603 5.57579 1.24951C5.58851
        1.25705 5.60174 1.26361 5.61388 1.27197C5.64604 1.29411 5.67707 1.31955 5.70567
        1.34814L9.80138 5.44482C10.0548 5.6987 10.0551 6.11007 9.80138 6.36377C9.54766 6.61718
        9.13621 6.61708 8.88243 6.36377L5.8961 3.37744V18.1919C5.89583 18.5506 5.60453 18.8423
        5.24571 18.8423C4.88694 18.8422 4.59559 18.5506 4.59532 18.1919V3.37744L1.60997
        6.36377C1.35622 6.61734 0.943858 6.61725 0.690048 6.36377C0.436505 6.1101 0.436785
        5.69867 0.690048 5.44482L4.78575 1.34814C4.85418 1.27963 4.93854 1.22846 5.03185
        1.1958C5.05452 1.18789 5.07694 1.17965 5.1002 1.17432C5.11746 1.17036 5.1352 1.16906
        5.15294 1.1665C5.17635 1.16312 5.19965 1.16049 5.22325 1.15967C5.23073 1.15941 5.23817
        1.15772 5.24571 1.15771C5.25454 1.15771 5.26334 1.15932 5.27208 1.15967Z"
        fill="currentColor"
      />
      <path
        d="M15.7373 1.15771C16.0962 1.15771 16.3875 1.4492 16.3876 1.80811V16.6226L19.374
        13.6362C19.6277 13.3827 20.0391 13.3827 20.2929 13.6362C20.5468 13.8901 20.5468
        14.3023 20.2929 14.5562L16.1972 18.6519C16.167 18.682 16.1332 18.7081 16.0976
        18.7319C16.087 18.739 16.0753 18.7441 16.0644 18.7505C16.0378 18.7661 16.0112 18.7817
        15.9824 18.7935C15.9766 18.7958 15.9706 18.7972 15.9648 18.7993C15.9319 18.8116
        15.8984 18.8227 15.8632 18.8296C15.8216 18.8377 15.7795 18.8414 15.7373
        18.8413V18.8423C15.7247 18.8423 15.7125 18.8391 15.7001 18.8384C15.6707 18.8367
        15.6413 18.8353 15.6123 18.8296C15.5757 18.8224 15.5408 18.8113 15.5068 18.7983C15.502
        18.7965 15.4969 18.7954 15.4921 18.7935C15.4115 18.7605 15.3389 18.7124 15.2783
        18.6519L11.1816 14.5562C10.9278 14.3023 10.9279 13.8901 11.1816 13.6362C11.4354
        13.3824 11.8477 13.3824 12.1015 13.6362L15.0869 16.6216V1.80811C15.087 1.44932 15.3785
        1.15791 15.7373 1.15771Z"
        fill="currentColor"
      />
    </Icon>
  );
}
